import {Component, Input, OnInit} from '@angular/core';
import {BaseFilterCellComponent, FilterService} from '@progress/kendo-angular-treelist';
import {CompositeFilterDescriptor} from '@progress/kendo-data-query';

@Component({
  selector: 'gc-tree-grid-dropdown-filter',
  templateUrl: './tree-grid-dropdown-filter.component.html',
  styleUrls: ['./tree-grid-dropdown-filter.component.css']
})
export class TreeGridDropdownFilterComponent extends BaseFilterCellComponent {

  public get selectedValue(): any {
    const filter = this.filterByField(this.field);
    return filter ? filter.value : null;
  }

  @Input() public filter: CompositeFilterDescriptor;
  @Input() public data: any[];
  @Input() public textField: string;
  @Input() public valueField: string;
  @Input() public field: string;

  public get defaultItem(): any {
    return {
      [this.textField]: 'Select item...',
      [this.valueField]: null
    };
  }

  constructor(filterService: FilterService) {
    super(filterService);
  }

  public onChange(value: any): void {
    this.applyFilter(
      value === null ? // value of the default item
        this.removeFilter(this.field) : // remove the filter
        this.updateFilter({ // add a filter for the field with the value
          field: this.field,
          operator: 'eq',
          value
        })
    ); // update the root filter
  }
}
